import { createReducer } from '@reduxjs/toolkit';
import { SET_LAST_PLAYED_SONGS } from '../actions/LastPlayedSongsAction';

const initialState = {
    lastPlayedSongs: [],
    lastPlayedSongsMetaId: 'antena_1', // default stream (metaId). This avoids rerendering on the client, in most cases
    lastPlayedSongsUpdated: false,
};

const lastPlayedSongs = createReducer(initialState, (builder) => {
    builder.addCase(SET_LAST_PLAYED_SONGS, (state, action) => {
        state.lastPlayedSongs = action.lastPlayedSongs;
        state.lastPlayedSongsMetaId = action.metaId;
        state.lastPlayedSongsUpdated = Date.now();
    });
});

export default lastPlayedSongs;
